<script lang="ts" setup>
import Icon from '@/components/shared/Icon.vue'

defineProps<{
  name: string
  hint?: string
  required?: boolean
}>()
</script>

<template>
  <div class="flex gap-x-1.5 items-center pointer-events-none">
    <Icon
      v-if="hint"
      variant="info"
      class="w-4 h-4 text-gray-800 dark:text-gray-400"
      :stroke-width="2.25"
    />
    <label :for="name" class="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400">
      <slot />
      <sup v-if="required" class="ml-0.5 text-error-500">*</sup>
    </label>
  </div>
</template>
